import request from '@/utils/request'
import qs from 'qs'

// 平台首页的短信数量及投诉数量
export function getIndexMessageComplaintCount() {
  return request({
    url: '/static/getIndexMessageComplaintCount',
    method: 'get',
  })
}
// 厂家端首页 账户金额/判断是否有最新消息
export function getFactoryAmountMsg() {
  return request({
    url: '/static/getFactoryAmountMsg',
    method: 'get',
  })
}

// 服务商端首页备件押金金额
export function getSiteFittingDeposit() {
  return request({
    url: '/static/getSiteFittingDeposit',
    method: 'get',
  })
}

// 首页的备件统计数据
export function indexFittingStatic() {
  return request({
    url: '/static/indexFittingStatic',
    method: 'get',
  })
}

// 首页的工单统计数据
export function indexOrderStatic(query) {
  return request({
    url: '/static/indexOrderStatic',
    method: 'get',
    params: query
  })
}

// 一周单量变化
export function indexWeekOrderStatic() {
  return request({
    url: '/static/indexWeekOrderStatic',
    method: 'get',
  })
}

// 点击立即支付生成订单
export function scPlatOrderSign(data) {
  return request({
    url: '/toCollections/scPlatOrderSign',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: qs.stringify(data)
  })
}

// 点击立即支付生成订单
export function getPlatformAccount() {
  return request({
    url: '/companyInformationSetting/getPlatformAccount',
    method: 'get',
  })
}

// 查询订单状态
export function getAccountStatus(data) {
  return request({
    url: '/toCollections/status',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: qs.stringify(data)
  })
}

// 取消订单
export function cancelAccount(data) {
  return request({
    url: '/toCollections/cancel',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: qs.stringify(data)
  })
}

// 下载
export function technicalDownload(query) {
  return request({
    url: '/factoryTechnical/technicalDownload',
    method: 'get',
    params: query
  })
}

// 查询状态
export function checkSetType() {
  return request({
    url: '/static/checkSetType',
    method: 'get',
  })
}

